import React, { useState, useEffect, useRef } from 'react'
import EnrollmentLayout from '../Layout'
import { QuestionContainer } from '../Layout/Layout.styled'
import SectionError from 'components/SectionError'
import { CheckboxList } from 'styled'
import Message from 'components/Message'
import { HandleRequest, HandleResponse } from '../uses/HandleRequestApi.js'

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const index = (props) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  const [submit, setSubmit] = useState()
  const [canGoNext, setCanGoNext] = useState(false)
  const [recipes, setRecipes] = useState([])
  const [recipesSelected, setRecipesSelected] = useState([])

  const recipeRef = useRef(null)

  useEffect(() => {
    const fetchData = async () => {
      const response = await HandleRequest({ ...props })
      if (response && response.hasError) {
        setError(response.message)
      } else if (response && !response.hasError) {
        const catalogs = response.catalogs
        const mealPlan = response.enrollment.mealPlan

        if (catalogs.recipes && catalogs.recipes.length > 0) {
          setRecipes(
            catalogs.recipes.map((r) => {
              return {
                value: r.id,
                label: r.name,
              }
            }),
          )
        }

        if (mealPlan.recipes_favorites && mealPlan.recipes_favorites.length > 0) {
          setRecipesSelected(mealPlan.recipes_favorites)
        }
      }
      setLoading(false)
    }
    fetchData()
  }, [])

  useEffect(() => {
    validate()
  }, [recipesSelected])

  const saveCallback = async ({ goBack }) => {
    const data = {
      recipes_favorites: recipesSelected,
    }
    let response = false
    if (goBack) {
      response = await HandleResponse({ ...props, data, goBack })
    } else {
      setSubmit(true)
      validate(true)
      if (canGoNext) {
        response = await HandleResponse({ ...props, data, goBack })
      }
    }
    return response
  }

  const validate = (shouldFocusError) => {
    let canGoNext = recipesSelected.length >= 5
    setCanGoNext(canGoNext)
    if (!canGoNext && shouldFocusError && !loading) {
      scrollToRef(recipeRef)
    }
  }

  return (
    <EnrollmentLayout {...{ ...props, loading, canGoNext, saveCallback, section: 'meal_plan' }}>
      {!loading && error && <SectionError type={error} />}
      {!loading && !error && (
        <QuestionContainer ref={recipeRef}>
          {submit && recipesSelected.length < 5 && (
            <Message
              type="error"
              message={`You need to select at least 5 options in this question`}
              textStyle={{ fontSize: '15px' }}
              isMealPlan={true}
            />
          )}
          <div className="question">
            <p className="title">Which of our favorites might you be interested in being a part of your Meal Plan?</p>
            <p>Please select at least 5 options</p>
          </div>
          <div className="content">
            <CheckboxList
              value={recipesSelected}
              options={recipes}
              // className={ingredientsSelected.length >= 10 ? 'fake-disabled' : ''}
              onChange={setRecipesSelected}
            />
          </div>
        </QuestionContainer>
      )}
    </EnrollmentLayout>
  )
}

export default index
